import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlanwertPageComponent } from './planwert-page/planwert-page.component';

export const planwertRoutes: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
    },
    {   // lists all Planwerte
        path: 'list',
        component: PlanwertPageComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(planwertRoutes),
    ],
    exports: [
        RouterModule,
    ],
})
export class PlanwertRoutingModule {
}
